/* Blog Hub: instant subject + keyword filtering, no page reloads. */
(function () {
  function init(root) {
    if (root.dataset.guidesReady) return;
    root.dataset.guidesReady = '1';

    var input = root.querySelector('.alyn-guides__input');
    var pills = [].slice.call(root.querySelectorAll('.alyn-guides__pill'));
    var cards = [].slice.call(root.querySelectorAll('.alyn-guides__card'));
    var empty = root.querySelector('.alyn-guides__empty');
    var count = root.querySelector('.alyn-guides__count');
    var tag = '';
    var q = '';

    function apply() {
      var shown = 0;
      cards.forEach(function (c) {
        var okTag = !tag || ('|' + (c.dataset.tags || '') + '|').indexOf('|' + tag + '|') > -1;
        var okQ = !q || (c.dataset.text || '').indexOf(q) > -1;
        var vis = okTag && okQ;
        c.hidden = !vis;
        if (vis) shown++;
      });
      if (empty) empty.hidden = shown > 0;
      if (count) count.textContent = shown === cards.length ? '' : shown + ' of ' + cards.length;
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function (e) {
        e.preventDefault();
        tag = p.dataset.tag || '';
        pills.forEach(function (x) {
          x.classList.toggle('is-active', x === p);
          if (x === p) { x.setAttribute('aria-current', 'true'); } else { x.removeAttribute('aria-current'); }
        });
        apply();
        if (window.history && history.replaceState) { history.replaceState(null, '', p.getAttribute('href')); }
      });
    });

    if (input) {
      input.addEventListener('input', function () { q = input.value.toLowerCase().trim(); apply(); });
    }

    var m = location.pathname.match(/\/tagged\/([^\/?#]+)/);
    if (m) {
      var h = decodeURIComponent(m[1]);
      pills.forEach(function (p) {
        if ((p.getAttribute('href') || '').indexOf('/tagged/' + h) > -1) { p.click(); }
      });
    }
  }

  function boot() { document.querySelectorAll('.alyn-guides').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
